import { ErrorHandler } from '@src/components/ErrorHandler';
import { Table as TableComponent } from '@src/components/Table-static';
import { Visibility } from '@src/features/Users/components/Visibility';
import { Box } from '@uhg-abyss/web/ui/Box';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { isEqual, orderBy } from 'lodash';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import configuration from './includes/configuration.json';

/**
 * Table: ProtectInformation
 *
 * Displays a list of fields from the workable item from the PROTECT database.
 *
 * @param props
 * @returns {Element}
 * @constructor
 */
export function Table(props) {
  const { rows } = props;

  /**
   * renderCellField
   *
   * Displays the field of the workable item within a cell.
   *
   * @param args
   * @returns {*}
   */
  const renderCellField = (args) => {
    const { cell } = args;

    return <strong>{cell?.value}</strong>;
  };

  /**
   * renderCellOriginalValue
   *
   * Displays the original value of the field from the workable item within a cell.
   *
   * @param args
   * @returns {*}
   */
  const renderCellOriginalValue = (args) => {
    const { cell } = args;

    return cell?.value;
  };

  /**
   * renderCellNewValue
   *
   * Displays the New value of the field from the workable item within a cell.
   *
   * @param args
   * @returns {*}
   */
  const renderCellNewValue = (args) => {
    const { cell, row } = args;

    if (!isEqual(row?.original?.originalValue, row?.original?.newValue)) {
      return (
        <Box
          color="$tint2"
          css={{
            marginLeft: '-10px',
            marginRight: '-10px',
            padding: 0,
            position: 'absolute',
          }}
        >
          <Layout.Group
            css={{
              height: '100%',
              marginLeft: '6px',
              marginRight: '6px',
            }}
          >
            {cell?.value}
          </Layout.Group>
        </Box>
      );
    }

    return cell?.value;
  };

  /**
   * Columns for table.
   */
  const columns = useMemo(() => {
    return orderBy(configuration?.initialColumns, ['order'], ['asc']).map((item) => {
      const column = item;

      if (column.Header === 'Field') {
        column.Cell = renderCellField;
      }

      if (column.Header === 'Original Value') {
        column.Cell = renderCellOriginalValue;
      }

      if (column.Header === 'New Value') {
        column.Cell = renderCellNewValue;
      }

      return column;
    });
  }, []);

  return (
    <ErrorHandler location="src/routes/private/WorkQueue/screens/View/components/ProtectInformation/components/Table/Table.jsx">
      <Visibility>
        <TableComponent
          {...{
            accessor: 'ProtectInformation',
            columns,
            configuration,
            rows,
          }}
        />
      </Visibility>
    </ErrorHandler>
  );
}

Table.propTypes = {
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      field: PropTypes.string,
      newValue: PropTypes.string,
      originalValue: PropTypes.string,
    })
  ),
};

Table.defaultProps = {
  rows: [],
};
